import { useEffect, useState } from "react";
import { IStylingPanelMode, stylingPanelModeStore } from "../../right-panel/styling-panel/styling-panel-mode-store";

/** The styling panel's current mode (state / tag-edit), for the selection bar's style writers. */
export function useStylingPanelMode(): IStylingPanelMode {
  const [mode, setMode] = useState<IStylingPanelMode>(stylingPanelModeStore.getSnapshot);

  useEffect((): (() => void) => {
    const update = (): void => setMode(stylingPanelModeStore.getSnapshot());
    const unsubscribe: () => void = stylingPanelModeStore.subscribe(update);
    // Catch a change published between the first render and this effect.
    update();
    return unsubscribe;
  }, []);

  return mode;
}
